<template>
  <div class="pagination"
       :style="{'margin-top': setMargin()}">
    <div class="page-size">
      <select v-model="selectedRows"
        @change="setPageSize()">
        <option v-for="item in rows"
          :key="item"
          :value="item">
          {{item}}
        </option>
      </select>
      <localized-label>tableRowsPerPageText</localized-label>
      <div v-if="pages.length > 1" class="paging">
        <div class="page-item"
          @click="selectPage('first')">
          <i class="n-i n-i-arrow-left-b"></i>
          <i class="n-i n-i-arrow-left-b"></i>
        </div>
        <div class="page-item"
          @click="selectPage('previous')">
          <i class="n-i n-i-arrow-left-b"></i>
        </div>
        <div class="active-page-items"
          v-for="(page, index) in pages"
          :key="`${page}${index}`"
          @click="onPageChange(page)"
          :class="{'active-page': setActivePage(page)}">
          {{page}}
        </div>
        <div class="page-item"
          @click="selectPage('next')">
          <i class="n-i n-i-arrow-right-b"></i>
        </div>
        <div class="page-item"
          @click="selectPage('last')">
          <i class="n-i n-i-arrow-right-b"></i>
          <i class="n-i n-i-arrow-right-b"></i>
        </div>
      </div>
    </div>
    <div class="total">
      <div>
        <localized-label>tableTotalResultsText</localized-label>
        <span>: {{totalItems}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  concat,
  isNumber,
  isNil,
  slice,
} from 'lodash';

export default {
  name: 'Pagination',
  props: {
    page: {
      type: Number,
    },
    row: {
      type: Number,
    },
    rows: {
      type: Array,
    },
    totalItems: {
      type: Number,
    },
    totalPages: {
      type: Number,
    },
  },
  data() {
    return {
      activePage: null,
      currentPage: 1,
      selectedRows: this.row,
      totalPagesItems: [],
      pages: [],
    };
  },
  watch: {
    row(update) {
      this.selectedRows = update;
    },
    totalPages(update, current) {
      if (update !== current) {
        this.setTotalPages(update);
        this.pages = this.totalPages >= 10 ? this.setPages() : this.totalPagesItems;
      }
    },
    page(update) {
      if (update) {
        this.activePage = update;
        this.pages = this.totalPages >= 10 ? this.setPages() : this.totalPagesItems;
      }
    },
    currentPage() {
      this.$emit('setPages', {
        page: this.currentPage,
        pageSize: this.selectedRows,
      });
    },
  },
  computed: {
  },
  methods: {
    onPageChange(value) {
      if (isNumber(value)) {
        this.currentPage = value;
      }
    },
    setActivePage(value) {
      return this.activePage === value;
    },
    setPages() {
      let pages = [];
      if (this.activePage <= 5) {
        pages = slice(this.totalPagesItems, 0, 8);
        pages[pages.length - 1] = '...';
      } else {
        pages = this.activePage >= this.totalPagesItems.length - 4
          ? slice(this.totalPagesItems, this.totalPagesItems.length - 8,
            this.totalPagesItems.length - 1)
          : slice(this.totalPagesItems, this.activePage - 4, this.activePage + 3);
        pages[pages.length - 1] = this.activePage >= this.totalPagesItems.length - 4
          ? this.totalPagesItems.length - 1 : '...';
        pages[0] = '...';
        pages.unshift(1);
      }
      pages = concat(pages, this.totalPagesItems.length);
      return pages;
    },
    selectPage(value) {
      if (value === 'last') {
        this.currentPage = this.totalPages;
      } else if (value === 'previous') {
        this.currentPage = this.currentPage > 1 ? this.currentPage - 1 : 1;
      } else if (value === 'next') {
        this.currentPage = this.currentPage < this.totalPages
          ? this.currentPage + 1 : this.totalPages;
      } else this.currentPage = 1;
    },
    setPageSize() {
      this.currentPage = 1;
      this.$emit('setPages', {
        page: 1,
        pageSize: this.selectedRows,
      });
    },
    setTotalPages() {
      this.totalPagesItems = [];
      for (let pageNumber = 1; pageNumber <= this.totalPages; pageNumber += 1) {
        this.totalPagesItems = concat(this.totalPagesItems, pageNumber);
      }
    },
    setMargin() {
      return `${isNil(this.totalItems) || this.totalItems === 0 ? 5 : 0}px`;
    },
  },
};
</script>
<style lang="scss" scoped>
.pagination {
  width: 100%;
  height: 55px;
  background-color: $tablePattensBlue;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  div select {
    width: 65px;
    height: 35px;
    background: #fff;
    color: #727b8a;
    border: 1px solid #bfc5cd;
  }
  .page-size {
    display: flex;
    align-items: center;
    > span {
      padding-left: 10px;
      font-size: 12px;
      color: #bcc2c6;
    }
    select {
      -webkit-appearance: menulist;
    }
  }
  .paging {
    margin-left: 40px;
    display: flex;
    align-items: center;
    div {
      width: 30px;
      height: 28px;
      margin-left: 2px;
    }
    .active-page-items {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color:#808b9c;
      cursor: pointer;
    }
    .active-page {
      background-color: #bfc5cd;
      color: #ffff;
    }
    .page-item {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #bfc5cd;
      cursor: pointer;
      &:nth-child(n+1) {
        color: #ffff;
      }
    }
  }
  .total {
    display: flex;
    align-items: center;
    color: #808b9c;
    font-size: 12px;
  }
}
</style>
